export const base64StringToByteSize = base64 => {
    return 3*Math.ceil(base64.length / 4); // 4 base64-chars = 3 bytes.  (each base64-char is 6 bits, each byte is 8 bits)
};


// WEBPACK FOOTER //
// ./src/common/src/util/base64Util.js